// extracted by mini-css-extract-plugin
module.exports = {"returning":"zF","item":"AF","image":"BF","buttons":"CF","disabled":"DF"};